"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.544 1.168C0.800001 0.807881 1.13824 0.514045 1.53061 0.310902C1.92298 0.107759 2.35816 0.00117388 2.8 0H17.2C18.136 0 18.953 0.47 19.456 1.168C19.799 1.646 20 2.235 20 2.867V13.133C20 14.682 18.78 16 17.2 16H2.8C1.22 16 0 14.682 0 13.133V2.867C0 2.235 0.2 1.646 0.544 1.167V1.168ZM2.933 2L9.26 8.965C9.35373 9.06812 9.46797 9.15051 9.59541 9.20689C9.72284 9.26327 9.86065 9.29239 10 9.29239C10.1393 9.29239 10.2772 9.26327 10.4046 9.20689C10.532 9.15051 10.6463 9.06812 10.74 8.965L17.067 2H2.933ZM18 3.948L12.22 10.31C11.9388 10.6194 11.5961 10.8665 11.2138 11.0357C10.8315 11.2048 10.418 11.2922 10 11.2922C9.58195 11.2922 9.16852 11.2048 8.78622 11.0357C8.40391 10.8665 8.06118 10.6194 7.78 10.31L2 3.948V13.133C2 13.647 2.392 14 2.8 14H17.2C17.608 14 18 13.647 18 13.133V3.948Z",
    fill: fill
  }));
};

exports["default"] = _default;